import { NgIf } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrimeNGModule } from '../../primeng.module';
import { CarouselProductsComponent } from '../../shared/components/carousel-products/carousel-products.component';
import { SliderSwiperComponent } from '../../shared/components/slider-swiper/slider-swiper.component';
import { YoutubeVideoComponent } from '../../shared/components/youtube-video/youtube-video.component';
import { Product } from '../../shared/models/product/product';
import User from '../../shared/models/user/user';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    NgIf,
    PrimeNGModule,
    YoutubeVideoComponent,
    SliderSwiperComponent,
    CarouselProductsComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  public categories: any[] = [];
  public videos: any[] = [];
  public screenWidth: any;
  public informations: any[] = [];
  public user: User = new User();
  public productsFeatured: Product[] = [];
  public showSkeleton = true;
  public showSkeletonCarrousel = true;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}
  slides: any[] = [];

  ngOnInit(): void {
    const data = this.activatedRoute.snapshot.data;

    this.slides = data['slides'] || [];
    this.videos = data['data']?.videos || [];
    this.productsFeatured = data['featuredProducts'] || [];

    this.showSkeletonCarrousel = !(this.productsFeatured?.length > 0);
  }

  onClickCategories(item: any) {
    this.router.navigate([item.url]);
  }
}
